/**************************************************
 * Nombre:       Home_Somos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import foto from '../../../Recursos/foto_nosotros.png'
import ic_mision from '../../../Recursos/ic_mision.svg'
import ic_vision from '../../../Recursos/ic_vision.svg'
import ic_objetivo from '../../../Recursos/ic_objetivo.svg'
import Tarjeta_Mision from "../../Tarjetas/Tarjeta_Mision";
import BarraProgreso from "./SucComponentes/BarraProgreso";
import Zoom from 'react-reveal/Zoom';


const Home_Somos = () => {


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
                spacing={6}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      alignItems={'flex-start'}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 4}}
                        spacing={0}
                        sx={{mt: 4}}
                    >
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, color: theme.palette.primary.main, fontWeight: 600}}>Quiénes
                                somos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 40, fontFamily: NEGRITA, lineHeight: 1.1, fontWeight: 400}}>
                                Dedicados a transformar tu futuro a través de la educación
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 16}}>
                                Potenciamos tu talento con metodologías activas y centradas en ti. Unimos creatividad y
                                pensamiento crítico para conectar tu propósito con el mundo laboral. Fórmate con
                                innovación para el éxito real
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>


                            {progresos.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 3}}>

                                            <BarraProgreso item={it}/>

                                    </Grid>
                                )
                            })}

                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 8}}>

                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                                sx={{py: 3}}
                            >

                                {items.map((item, i) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Zoom>
                                        <Tarjeta_Mision item={item}/>
                                        </Zoom>
                                    </Grid>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}}
                              sx={{justifyContent: 'flex-start', ml: -23, zIndex: 1}}>
                            <img src={foto} width={'150%'} height={'auto'}/>
                        </Grid>

                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Somos

const items = [
    {
        img: ic_mision,
        nombre: 'Misión',
        descripcion: 'Transformamos vidas en la región de Nariño mediante una formación técnica laboral accesible, pertinente y de alta calidad. A través de metodologías activas y prácticas, desarrollamos competencias reales en nuestros estudiantes, preparándolos con éxito para los desafíos del mercado laboral del siglo XXI y el progreso de sus comunidades.'
    },
    {
        img: ic_vision,
        nombre: 'Visión',
        descripcion: 'Ser reconocidos como la institución técnica líder en innovación pedagógica y regionalización en el suroccidente colombiano. Nos proyectamos como el puente principal para que nuestros egresados continúen su trayectoria hacia la educación profesional, consolidando un ecosistema educativo que impulsa el desarrollo sostenible y el tejido social.'
    },
    {
        img: ic_objetivo,
        nombre: 'Objetivo Institucional',
        descripcion: 'Garantizar una formación técnica laboral integral y de vanguardia mediante el modelo de Escuelas de Aprendizaje, facilitando la empleabilidad inmediata de los jóvenes de Nariño. Buscamos resolver las necesidades del mercado laboral regional ofreciendo programas accesibles, flexibles y con rutas claras de profesionalización universitaria.'
    },
]

const progresos = [
    {
        nombre: 'Excelencia Académica',
        porcentaje: 87
    },
    {
        nombre: 'Satisfacción Estudiantil',
        porcentaje: 95
    },
    {
        nombre: 'Preparación para el Empleo',
        porcentaje: 99
    },
    {
        nombre: 'Empleabilidad',
        porcentaje: 94
    },
]